/* eslint-disable @tencent/i18next/no-literal-string */
import React, { useEffect, useRef, useState } from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import i18n from '@i18next/i18n';
import PageRange from '../range';
import { transaction } from '@src/js/utils';
import { DialogProps, QUICK_TOOL_AID_FEATURE } from '..';
import { showVipLinktext } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import Loading from '@tencent/dui/lib/components/Loading';
import Radio from '@tencent/dui/lib/components/Radio';
import style from './style.less';

const apprec = 'textdesensitization';
type ITextDesensitizationDialog = React.FC<DialogProps>;
const TextDesensitizationDialog: ITextDesensitizationDialog = (props: DialogProps) => {
    const {
        visible, onClose, onOk, position, services,
    } = props;
    const [slideList, setSlideList] = useState<ISlideModel[]>();
    const [keepUnit, setKeepUnit] = useState(true);

    const handleOk = async () => {
        if (!onOk(apprec, i18n.t('数字内容脱敏')) || !slideList) {
            return;
        }
        const loading = Loading.show({ tip: i18n.t('加载中...') });
        const timeout = setTimeout(async () => {
            await Promise.all(slideList?.map(async (slide) => {
                !slide.childrenConverted && await slide.startConvertChildrenTask(TaskPriority.HIGH);
            }));
            transaction(() => {
                if (!slideList) {
                    return;
                }
                services.numberTestManager?.replaceSensitiveData(slideList, keepUnit);
            });
            onClose();
            loading.close();
            clearTimeout(timeout);
        }, 0);
    };
    const vipLinkRef = useRef(null);
    useEffect(() => {
        showVipLinktext({
            ref: vipLinkRef.current,
            name: i18n.t('数字内容脱敏'),
            feature: QUICK_TOOL_AID_FEATURE,
            position,
            apprec,
            anchor: 'PPT-TOOLS',
        });
    }, [vipLinkRef.current]);

    return (
        <Modal
            title={i18n.t('数字内容脱敏')}
            visible={visible}
            onClose={onClose}
            onCancel={onClose}
            onOk={handleOk}
            className={style['text-desensitization-dialog']}
        >
            <div style={{ width: '100%', marginBottom: '10px' }} ref={vipLinkRef}></div>
            <div className={style['preview-container']}></div>
            <div className={style['desensitization-title']}>{i18n.t('脱敏效果')}</div>
            <Radio.Group onChange={value => setKeepUnit(!!value)} value={keepUnit ? 1 : 0}>
                <Radio value={1}>
                    <div className={style['radio-button']}>
                        {i18n.t('数字转为***，但是保留“百、千、万、亿”等计数单位')}
                    </div>
                    <div className={style['radio-describe']}>
                        {i18n.t('如：100万、一百万、1百万，都转为***万')}
                    </div>
                </Radio>
                <Radio value={0}>
                    <div className={style['radio-button']}>
                        {i18n.t('数字都转为***')}
                    </div>
                    <div className={style['radio-describe']}>
                        {i18n.t('包括中文、阿拉伯数字，如：一百万、壹佰万、1000000')}
                    </div>
                </Radio>
            </Radio.Group>
            <PageRange
                needGetSelectModels={false}
                onCheckStateChange={list => setSlideList(list)}
                services={{
                    masterLayoutEditService: services.masterLayoutEditService,
                    selectionService: services.selectionService,
                }}>
            </PageRange>
        </Modal>
    );
};

export default TextDesensitizationDialog;
